import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { AiRequestUtilsService } from 'src/app/api/services/ai-request-utils.service';
import { ApiService } from 'src/app/api/services/api.service';
import { environment } from 'src/environments/environment';

export type ImproveTextAction =
  | 'longer'
  | 'shorter'
  | 'refine'
  | 'summarize_bullets'
  | 'fix_spelling'
  | 'translate_spanish';

export type ImproveTextTone =
  | 'friendly'
  | 'urgent'
  | 'formal'
  | 'positive'
  | 'impactful';

export interface ImproveTextRequest {
  text: string;
  sessionId: string;
  action?: ImproveTextAction;
  tone?: ImproveTextTone;
  customPrompt?: string;
}

export type ImproveTextResponse =
  | { type: 'editor_ai_text'; data: string; creditsUsed: number }
  | { type: 'no_credits'; data: string; creditsUsed: 0 };

@Injectable({ providedIn: 'root' })
export class TextAiApiService extends ApiService<ImproveTextResponse> {
  protected override APIUrl =
    environment.AI_SERVICE_URL + this.getResourceUrl();

  constructor(
    protected httpClient: HttpClient,
    private aiRequestUtils: AiRequestUtilsService,
  ) {
    super(httpClient);
  }

  override getResourceUrl(): string {
    return '/api/v1/editor-tools';
  }

  improveText(input: ImproveTextRequest): Promise<ImproveTextResponse> {
    const { headers, body } = this.aiRequestUtils.buildCall('', {
      sessionId: input.sessionId,
      includeEmail: true,
    });

    body.text = input.text;

    if (input.action) body.action = input.action;
    if (input.tone) body.tone = input.tone;
    if (input.customPrompt) body.customPrompt = input.customPrompt;

    return firstValueFrom(
      super.requestWithHeadersAsObservable(
        '',
        'POST',
        'improve-text',
        headers,
        undefined,
        body,
      ),
    );
  }
}
